function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCreditCardPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 7H4c-.548 0-1 .452-1 1v16c0 .241.116.502.407.793.09.09.326.207.593.207h24c.548 0 1-.452 1-1V8c0-.241-.116-.502-.407-.793C28.503 7.117 28.267 7 28 7zm1.3-.5C29 6.2 28.5 6 28 6H4c-1.1 0-2 .9-2 2v16c0 .6.3 1.1.7 1.5.3.3.8.5 1.3.5h24c1.1 0 2-.9 2-2V8c0-.6-.3-1.1-.7-1.5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 18.5v-1h11v1H4zM4 21.5v-1h7v1H4zM20 22.5h6c.3 0 .5-.2.5-.5v-5c0-.3-.2-.5-.5-.5h-6c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5zM2 10h28v4H2v-4z",
    fill: props.color
  }));
}

export default SvgIconCreditCardPlaceholder;